import { __assign, __rest } from "tslib";
import InternalContainer from '../container/internal';
import React from 'react';
export var ExpandableSectionContainer = function (_a) {
    var className = _a.className, children = _a.children, header = _a.header, variant = _a.variant, expanded = _a.expanded, disableContentPaddings = _a.disableContentPaddings, __internalRootRef = _a.__internalRootRef, rest = __rest(_a, ["className", "children", "header", "variant", "expanded", "disableContentPaddings", "__internalRootRef"]);
    if (variant === 'container') {
        return (React.createElement(InternalContainer, __assign({}, rest, { className: className, header: header, disableContentPaddings: disableContentPaddings || !expanded, disableHeaderPaddings: true, __internalRootRef: __internalRootRef }), children));
    }
    return (React.createElement("div", __assign({ className: className }, rest, { ref: __internalRootRef }),
        header,
        children));
};
//# sourceMappingURL=expandable-section-container.js.map